import { render } from "./QuotesStats.vue?vue&type=template&id=0d662c9d&scoped=true"
import script from "./QuotesStats.vue?vue&type=script&lang=js"
export * from "./QuotesStats.vue?vue&type=script&lang=js"

import "./QuotesStats.vue?vue&type=style&index=0&id=0d662c9d&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d662c9d"]])

export default __exports__